/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_3_TitleInputs */

const et_case_3_title = /** @type {(inputs: Case_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`75 700+ näitamist ja järjepidev sissetulev kasv`)
};

const en_case_3_title = /** @type {(inputs: Case_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`75,700+ impressions and consistent inbound growth`)
};

/**
* | output |
* | --- |
* | "75,700+ impressions and consistent inbound growth" |
*
* @param {Case_3_TitleInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const case_3_title = /** @type {((inputs?: Case_3_TitleInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_3_TitleInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_case_3_title(inputs)
	return en_case_3_title(inputs)
});